// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-d842d230] {\n  padding: 10px;\n}", ""]);
// Exports
module.exports = exports;
